import first from "./first_post.json"
import second from "./second_post.json"
import third from "./third_post.json"

const blogPosts = [third, second, first];
export default blogPosts;